import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
// ui
import { saveAs } from "file-saver";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
//
import { createStyles, makeStyles, styled } from "@material-ui/styles";
import ButtonMain from "../../common/components/button/ButtonMain";
import InputBasic from "../../common/components/input/InputBasic";
// style
// components
import TemplateHome from "../components/TemplateHome";

// utils,config
import moduleSetting from "../../config/config.module";
import { SNA_BASIC_SETTING } from "../../config/config.sna";
import fireDb from "../../api/firebase/realtime/utils";
import Act from "../../store/actions";
import { StoreContext } from "../../store/StoreProvider";

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

//
const RootSettingPage = () => {
  // style
  const classes = useStyles();
  // props

  //
  const [state, dispatch] = useContext(StoreContext);
  // local state
  const [emailInput, setEmailInput] = useState("");
  const [usersFind, setUserFind] = useState(null);

  const handleExportModuleSetting = () => {
    console.log("handleExportModuleSetting", JSON.stringify(moduleSetting));
    const blob = new Blob([JSON.stringify(moduleSetting, null, 2)], {
      type: "application/json;charset=utf-8",
    });
    saveAs(blob, "hsna-web-module-setting.json");
  };

  const handleExportSnaSetting = () => {
    console.log("handleExportSnaSetting", JSON.stringify(SNA_BASIC_SETTING));
    const blob = new Blob([JSON.stringify(SNA_BASIC_SETTING, null, 2)], {
      type: "application/json;charset=utf-8",
    });
    saveAs(blob, "hsna-web-sna-setting.json");
  };

  const handleUpdateEmailsLinkUser = () => {
    fireDb.updateEmailsLinkUser({
      onSuccess: () => {
        // error message
        dispatch({
          type: Act.COMMON_SET_SUCCESS_MESSAGE,
          payload: {
            open: true,
            content: "更新 emails 成功",
          },
        });
      },
      onError: (error) => {
        // error message
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: error.message,
          },
        });
      },
    });
  };

  const handleSearchUserByEmail = () => {
    fireDb.findUsersByEmail({
      email: emailInput,
      onSuccess: (users) => {
        setUserFind(users);
      },
      onError: (error) => {
        // error message
        dispatch({
          type: Act.COMMON_SET_ERROR_MESSAGE,
          payload: {
            open: true,
            content: error.message,
          },
        });
      },
    });
  };

  return (
    <TemplateHome>
      <Grid container justifyContent="center">
        <Grid item xs={12}>
          <Box pt={5} textAlign="center">
            <Typography variant="h5">RootSettingPage</Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box pt={5} textAlign="center">
            <Typography variant="h5">Export setting file</Typography>
          </Box>
        </Grid>
        <Grid item container xs={12} justifyContent="center">
          <Box mt={5} mx={5} textAlign="center">
            <ButtonMain
              buttonProps={{
                text: "export module setting",
                onClick: handleExportModuleSetting,
              }}
            />
          </Box>
          <Box mt={5} mx={5} textAlign="center">
            <ButtonMain
              buttonProps={{
                text: "export sna setting",
                onClick: handleExportSnaSetting,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box pt={5} textAlign="center">
            <Typography variant="h5">Update Emails of realtime</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} justifyContent="center">
          <Box mt={5} mx={5} textAlign="center">
            <ButtonMain
              buttonProps={{
                text: "update email link user",
                onClick: handleUpdateEmailsLinkUser,
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box pt={5} textAlign="center">
            <Typography variant="h5">Search User by email</Typography>
          </Box>
        </Grid>
        <Grid item>
          <InputBasic onChange={(e) => setEmailInput(e.target.value)} />
        </Grid>
        <Grid item xs={12} justifyContent="center">
          <Box mt={5} mx={5} textAlign="center">
            <ButtonMain
              buttonProps={{
                text: "Search User by email",
                onClick: handleSearchUserByEmail,
              }}
            />
          </Box>
        </Grid>
        <Grid item>
          <Typography>Users:</Typography>
          {usersFind &&
            Object.entries(usersFind).map(([uid, user], idx) => (
              <Box key={idx.toString()}>
                <Typography>displayName:{user?.info?.displayName}</Typography>
                <Typography>email:{user?.info?.email}</Typography>
              </Box>
            ))}
        </Grid>
      </Grid>
    </TemplateHome>
  );
};

RootSettingPage.propTypes = {};

RootSettingPage.defaultProps = {};

export default RootSettingPage;
